module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-07 (2).1729b4eb.svg";